<template>
  <v-card v-if="active" class="admin-upload-box" elevation="2">
    <div class="d-flex pa-4">
      <v-list-item-title>{{ headerMessage }}</v-list-item-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="hidePopup($event)"><v-icon>mdi-close</v-icon></v-btn>
    </div>
    <v-divider></v-divider>
    <v-card-text class="">
      <div class="admin-upload-box-main" v-if="!itemsAdded">
        <div class="form-group">
          <div
            class="admin-upload-drop-area"
            @ondragover="onChange"
            :class="dragging ? 'admin-upload-drop-areaDragging' : ''"
            @dragenter="dragging = true"
            @dragend="dragging = false"
            @dragleave="dragging = false">
            <h3>{{ dropAreaPrimaryMessage }}</h3>
            <input
              type="file"
              id="items"
              name="items[]"
              accept=".png,.jpg,.jpeg"
              required
              multiple
              @change="onChange" />
            <p class="help-block">{{ dropAreaSecondaryMessage }}</p>
          </div>
        </div>
      </div>
      <div class="admin-upload-box-main" v-else>
        <div class="admin-upload-box-files-container">
          <admin-stamps-upload-item
            :key="file"
            v-for="file in files"
            :file="file"
            @ondelete="onStampDelete"></admin-stamps-upload-item>
        </div>
        <p>
          <strong>{{ totalFileMessage }}</strong> {{ itemsAdded }}
        </p>
        <p>
          <strong>{{ totalUploadSizeMessage }}</strong> {{ itemsTotalSize }}
        </p>
      </div>
      <div class="successMsg" v-if="successMsg !== ''">{{ successMsg }}</div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="">
      <v-btn text color="error" @click="hidePopup()">
        {{ cancelButtonMessage }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn :disabled="filesToUpload.length < 1" @click="onSubmit()" color="primary">
        {{ uploadButtonMessage }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  /* eslint-disable no-useless-escape */
  import { saveMarkupStamp } from '@/utils/mongoUtils';
  import { ForgeMarkupStamp } from '@/scripts/js/forgeModels';
  import $ from 'jquery';
  export default {
    name: 'AdminStampsUpload',
    props: {
      headerMessage: {
        type: String,
        default: 'Add Stamps',
      },
      dropAreaPrimaryMessage: {
        type: String,
        default: 'Drop multiple files here',
      },
      dropAreaSecondaryMessage: {
        type: String,
        default: 'or click to upload',
      },
      fileNameMessage: {
        type: String,
        default: 'Names',
      },
      fileSizeMessage: {
        type: String,
        default: 'Sizes',
      },
      totalFileMessage: {
        type: String,
        default: 'Total files:',
      },
      totalUploadSizeMessage: {
        type: String,
        default: 'Total upload size:',
      },
      removeFileMessage: {
        type: String,
        default: 'Remove files',
      },
      uploadButtonMessage: {
        type: String,
        default: 'Upload',
      },
      cancelButtonMessage: {
        type: String,
        default: 'Cancel',
      },
    },

    data() {
      return {
        dragging: false,
        files: [],
        items: [],
        itemsAdded: '',
        itemsNames: [],
        itemsSizes: [],
        // itemsTotalSize: 0,
        itemsTotalSizeBytes: 0,
        formData: '',
        successMsg: '',
        errorMsg: '',
        isLoaderVisible: false,
      };
    },

    methods: {
      hidePopup() {
        this.active = false;
        this.removeItems();
      },
      // http://scratch99.com/web-development/javascript/convert-bytes-to-mb-kb/
      bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return 'n/a';
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        if (i === 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
      },

      getSvgTextFromImage(image_uri) {
        var _this = this;
        var svgText = '';

        $.get(
          {
            url: image_uri,
            async: false,
          },
          function (data) {
            var svg = $(data).find('svg');
            const styles = _this.parseElementStyle(svg[0].querySelector('style'));
            const elements = svg[0].querySelectorAll('[class]');
            for (let j = 0; j < elements.length; j += 1) {
              _this.applyElementStyles(elements[j], styles);
            }
            svg.removeAttr('xmlns:a');
            svgText = svg[0].outerHTML;
          },
          'xml',
        );
        return svgText;
      },
      parseElementStyle(styleTag) {
        if (!styleTag) {
          return {};
        }
        const classCollection = {};
        const plain = styleTag.innerHTML;
        const regex = /\.([^\s{]+)[\s]*\{([\s\S]+?)\}/;
        const propertyRegex = /([\w\-]+)[\s]*:[\s]*([^;]+)/;
        const result = plain.match(new RegExp(regex, 'g'));
        if (result) {
          result.forEach((c) => {
            const classResult = c.match(regex);
            const propertiesResult = classResult[2].match(new RegExp(propertyRegex, 'g'));
            const properties = propertiesResult.reduce((collection, item) => {
              const p = item.match(propertyRegex);
              collection[p[1]] = p[2];
              return collection;
            }, {});
            classCollection[classResult[1]] = properties;
          });
          return classCollection;
        }
        return {};
      },
      applyElementStyles(element, styles) {
        var _this = this;
        const classNames = (element.getAttribute('class') || '').split(' ');
        classNames.forEach((c) => {
          _this.applyElementProperties(element, styles[c]);
        });
        element.setAttribute('class', '');
      },
      applyElementProperties(element, properties) {
        if (!properties) {
          return;
        }
        Object.keys(properties).forEach((key) => {
          element.style[key] = properties[key];
        });
      },
      onChange(e) {
        this.successMsg = '';
        let files = e.target.files || e.dataTransfer.files;
        this.itemsAdded = files.length;
        let i = 0;
        for (let x in files) {
          if (!isNaN(x)) {
            this.items = e.target.files[x] || e.dataTransfer.files[x];
            this.itemsNames[x] = files[x].name;
            this.itemsSizes[x] = this.bytesToSize(files[x].size);
            this.itemsTotalSizeBytes += files[x].size;
            this.files.push({
              file: files[x],
              id: i,
              name: files[x].name,
              fileSize: this.bytesToSize(files[x].size),
              fileSizeBytes: files[x].size,
              lastModified: new Date(files[x].lastModified).toISOString().slice(0, 19),
              isUploaded: false,
              isUploading: false,
            });
            i++;
          }
        }
      },

      removeItems() {
        this.items = '';
        this.itemsAdded = '';
        this.itemsNames = [];
        this.itemsSizes = [];
        this.itemsTotalSizeBytes = 0;
        // this.itemsTotalSize = '';
        this.dragging = false;
        this.files = [];
      },

      onSubmit() {
        var _this = this;
        _this.isLoaderVisible = true;

        for (let i = 0; i < _this.files.length; i++) {
          var file = _this.files[i];
          file.svgPath = URL.createObjectURL(file.file);
          file.svgText = _this.getSvgTextFromImage(file.svgPath);
          if (!file.svgText) {
            continue;
          }
          file.isUploading = true;
          var stamp = new ForgeMarkupStamp();
          stamp.name = file.name;
          stamp.createDate = new Date().toDateString();
          stamp.userId = _this.$store.state.username;
          stamp.createdBy = _this.$store.state.username;
          stamp.svgText = file.svgText;
          stamp.folderPath = _this.folder.path;
          saveMarkupStamp(stamp);
          _this.folder.stamps.push(stamp);

          setTimeout(function () {
            _this.files[i].isUploaded = true;
          }, (i + 1) * 200);
        }
      },
      onStampDelete($event) {
        var _this = this;
        var uploadItem = $event;
        var index = _this.files.findIndex((o) => o.id == uploadItem.id);
        _this.files.splice(index, 1);
        _this.itemsTotalSizeBytes -= uploadItem.fileSizeBytes;
        _this.itemsAdded--;
      },
    },
    computed: {
      itemsTotalSize: function () {
        return this.bytesToSize(this.itemsTotalSizeBytes);
      },
      filesToUpload: function () {
        return this.files.filter((o) => !o.isUploading);
      },
      active: {
        get() {
          return this.$store.getters['getStampsUploadActive'];
        },
        set(value) {
          this.$store.commit('setStampsUploadActive', value);
        },
      },
      folder: {
        get() {
          return this.$store.getters['getStampsUploadFolder'];
        },
        set(value) {
          this.$store.commit('setStampsUploadFolder', value);
        },
      },
    },
  };
</script>

<style>
  .admin-upload-box {
    position: absolute;
    top: calc(50% - 300px);
    left: calc(50% - 300px);
    margin: auto;
    width: 600px;
    border-radius: 5px;
    animation-name: animatetop;
    animation-duration: 0.4s;
    z-index: 9999;
    user-select: none;
  }
  .admin-upload-box .admin-upload-box-main {
    position: relative;
    top: 10px;
    height: 390px;
  }

  /* Drag and drop */
  .admin-upload-box .admin-upload-drop-area {
    position: relative;
    width: calc(100% - 10px);
    height: 300px;
    border: 4px dashed var(--v-primary-base);
    text-align: center;
    font-size: 2em;
    padding-top: 80px;
    border-radius: 25px;
  }

  .admin-upload-box .admin-upload-drop-area input {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  /* End drag and drop */

  /* Loader */
  .admin-upload-box .loader {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    opacity: 0.9;
  }

  .admin-upload-box .loaderImg {
    border: 9px solid #eee;
    border-top: 9px solid #00adce;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* End Loader */

  .admin-upload-box-files-container {
    overflow: auto;
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
  }

  .admin-upload-box .errorMsg {
    font-size: 2em;
    color: #a94442;
  }

  .admin-upload-box .successMsg {
    font-size: 2em;
    color: #3c763d;
  }

  .admin-upload-box-footer {
    display: flex;
    justify-content: space-evenly;
  }

  .admin-upload-box-footer .decide-btn {
    height: 36px;
    width: 200px;
    margin: 5px;
    border-radius: 3px;
    font-family: var(--main-font);
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    line-height: normal;
    cursor: pointer;
  }

  .decide-btn.confirm {
    background: var(--v-primary-base);
    color: #ffffff;
  }

  .decide-btn.deny {
    color: rgba(189, 189, 189, 1);
    border: 1px solid #bdbdbd;
  }

  .decide-btn:hover {
    box-shadow: 0 3px 30px -2px rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 10%),
      0 1px 30px 0 rgb(0 0 0 / 10%);
  }

  .decide-btn.confirm:hover {
    background: var(--v-primary-darken2);
  }

  .decide-btn.deny:hover {
    background: var(--v-primary-lighten4);
  }

  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
